import { useQuery } from '@tanstack/react-query';

import { fetchDashboardMetrics } from '../api/metricsApi';

export function useDashboardMetrics() {
  return useQuery({
    queryKey: ['admin', 'metrics'] as const,
    queryFn: fetchDashboardMetrics,
  });
}
